import { render, staticRenderFns } from "./UiInfo.vue?vue&type=template&id=8c33d310&scoped=true&lang=pug"
import script from "./UiInfo.vue?vue&type=script&lang=js"
export * from "./UiInfo.vue?vue&type=script&lang=js"
import style0 from "./UiInfo.vue?vue&type=style&index=0&id=8c33d310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c33d310",
  null
  
)

export default component.exports